export default __webpack_public_path__ + "static/media/icon_details_black.da9499e2.svg";